export default __webpack_public_path__ + "76293ba620614e0f761ba5e384d858f0.svg";